import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Drawer, IconButton } from '@mui/material';
import getColorPresets from '@/utils/getColorPresets';
import useMobile from '@/hooks/useMobile';
import Iconify from '@/components//Iconify';

const getVariantBg = (variant) => {
  switch (variant) {
    case 'primary':
      return 'linear-gradient(90.08deg, #0000FF -9.69%, #FF77DE 24.82%, #FD9AE5 55.63%, #FF6F4D 97.71%)';
    case 'secondary':
      return 'linear-gradient(90.08deg, #0000FF -9.69%, #C5B2FD 14.22%, #C5B2FD 63.18%, #FECBF2 103.1%)';
    default:
      return 'linear-gradient(90.08deg, #0000FF -9.69%, #FF77DE 24.82%, #FD9AE5 55.63%, #FF6F4D 97.71%)';
  }
};

function PromoCard({ variant, title, desc, detail, cta, cb, renderContent }) {
  const { isMobile } = useMobile();
  const [open, setOpen] = useState(false);
  const color = getColorPresets('blue');
  const handlerButtonClicl = () => {
    if (renderContent) {
      setOpen(true);
    } else {
      cb();
    }
  };

  const handlerClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Box
        sx={{
          borderRadius: '8px',
          width: '100%',
          height: '52px',
          background: getVariantBg(variant),
        }}
      >
        <Box
          sx={{
            'border-radius': '8px',
            'width': '100%',
            'height': '52px',
            'background':
              'radial-gradient(circle at 0% 50%, #FFF 2%, rgba(0,0,0,0) 2%), radial-gradient(circle at 100% 50%, #FFF 2%, rgba(0,0,0,0) 2%)',
            'background-position': 'center left, center right',
            'background-size': '50%',
            'background-repeat': 'no-repeat',
            'display': 'flex',
            'alignItems': 'center',
            'justifyContent': 'flex-start',
          }}
        >
          <Typography
            component="div"
            variant="body2"
            fontWeight="bold"
            sx={{
              color: '#FFF',
              pl: isMobile ? 1 : 2,
              pr: isMobile ? 1 : 2,
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              flexDirection: 'column',
              borderLeft: () => `dashed 1px ${color.palette[700]}`,
            }}
          >
            <Typography
              component="div"
              variant="caption"
              sx={{
                color: (theme) => theme.palette.grey[900],
                pl: isMobile ? 1 : 2,
                pr: isMobile ? 1 : 2,
              }}
            >
              {desc}
            </Typography>
            <Typography
              component="div"
              variant="caption2"
              sx={{
                color: (theme) => theme.palette.grey[900],
                pl: isMobile ? 1 : 2,
                pr: isMobile ? 1 : 2,
              }}
            >
              {detail}
            </Typography>
          </Box>
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box>
            {isMobile ? (
              <IconButton onClick={handlerButtonClicl}>
                <Iconify
                  width={24}
                  height={24}
                  icon={'material-symbols:info-outline'}
                  sx={{ color: (theme) => theme.palette.primary.main }}
                />
              </IconButton>
            ) : (
              <Button
                onClick={handlerButtonClicl}
                variant="outlined"
                size="small"
                sx={{
                  mr: 2,
                  borderColor: '#FFF',
                  fontWeight: 600,
                  fontSize: '12px',
                  backgroundColor: 'rgba(255,255,255,0.5)',
                }}
              >
                {cta}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
      <>
        {renderContent && (
          <>
            {isMobile ? (
              <Drawer
                open={open}
                onClose={handlerClose}
                anchor="bottom"
                sx={{
                  '& .MuiPaper-root': {
                    borderTopLeftRadius: '24px',
                    borderTopRightRadius: '24px',
                  },
                }}
              >
                {renderContent(handlerClose)}
              </Drawer>
            ) : (
              <Drawer anchor="right" open={open} onClose={handlerClose}>
                {renderContent(handlerClose)}
              </Drawer>
            )}
          </>
        )}
      </>
    </>
  );
}

PromoCard.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  title: PropTypes.string,
  desc: PropTypes.string,
  detail: PropTypes.string,
  cta: PropTypes.string,
  cb: PropTypes.func,
  renderContent: PropTypes.func,
};

PromoCard.defaultProps = {
  variant: 'primary',
  title: 'MSI',
  desc: '',
  detail: '',
  cta: 'Detalles',
  cb: () => {},
  renderContent: null,
};

export default PromoCard;
